// TODO: Remove Volto universal link
import {UniversalLink} from "@plone/volto/components";

/**
 * @typedef {Object} Link
 * @property {string} title
 * @property {string} url
 * @property {boolean=} external
 */

/**
 * @param {Object} props
 * @param {string} props.title
 */
export function LinkListItemBody({ title }) {
  return (
    <>
      <span>{title}</span>
      <span
        className="material-icons nsw-material-icons"
        focusable="false"
        aria-hidden="true"
      >
        east
      </span>
    </>
  );
}

/**
 * @param {Object} props
 * @param {Link} props.link
 */
function LinkListItem({ link }) {
  // Handle special case where we don't want an interactable link
  if (link.url === "" && link.title) {
    return (
      <li>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href="" inert="">
          <LinkListItemBody title={link.title} />
        </a>
      </li>
    );
  }

  const url = typeof link === "string" ? link : link.url;
  const title = link.title || url;

  
  if (!url) {
    return null;
  }
  
  return (
    <li>
      <UniversalLink href={url}>
        <LinkListItemBody title={title} />
      </UniversalLink>
    </li>
  );
}

/**
 * @param {Object} props
 * @param {string=} props.title
 * @param {ReactNode} props.children
 */
export function LinkListWrapper({ title, children }) {
  return (
    <div className="nsw-link-list">
      {title ? <div className="nsw-link-list__title">{title}</div> : null}
      <ul>{children}</ul>
    </div>
  );
}

/**
 *
 * @param {Object} props
 * @param {string=} props.title
 * @param {Link[] | string[] } props.links - List of links. Can mix and match types (typedef is wrong)
 */
export function LinkList({ title, links }) {
  if (!links || !Array.isArray(links)) {
    return null;
  }
  if (links.length < 1) {
    return null;
  }

  return (
    <LinkListWrapper title={title}>
      {links.map((link, index) => {
        return <LinkListItem key={index} link={link} />;
      })}
    </LinkListWrapper>
  );
}

export function LinkListBlock({ data }) {
  return <LinkListItem link={data} />;
}
